(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      window.addEventListener('scroll', this.onScroll.bind(this), false);
      this.createObserver();
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    }
  }


  const stableCartIconSvg = `
  <svg class="header__cart-custom-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">
    <rect
      x="3"
      y="6"
      width="14"
      height="11"
      rx="0"
      stroke="currentColor"
      stroke-width="1.8"></rect>

    <path
      d="M6 6V4.8C6 3.25 7.35 2 9 2H11C12.65 2 14 3.25 14 4.8V6"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"></path>
  </svg>
`;

  function keepStableCartIcon() {
    const cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink) return;

    let wrapper = cartLink.querySelector('.svg-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('span');
      wrapper.className = 'svg-wrapper';
      cartLink.insertBefore(wrapper, cartLink.firstChild);
    }

    const currentIcon = wrapper.querySelector('.header__cart-custom-icon');
    if (!currentIcon) {
      wrapper.innerHTML = stableCartIconSvg;
    }
  }

  document.addEventListener('DOMContentLoaded', keepStableCartIcon);
  document.addEventListener('cart:updated', keepStableCartIcon);

  const cartIconObserver = new MutationObserver(keepStableCartIcon);
  cartIconObserver.observe(document.documentElement, { childList: true, subtree: true });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
